import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";
import { useUserActiveOrganization } from "../user/useUserActiveOrganization";

const STANDING_OFFER_CANCEL = gql(`
  mutation standingOfferCancel($standingOfferId: ID!, $organizationId: ID!) {
    standingOfferCancel(standingOfferId: $standingOfferId, organizationId: $organizationId) {
      ... on StandingOffer {
        __typename
        id
        status
      }
      ... on SubscriptionOfferNotFound {
        __typename
        id
      }
    }
  }
`);

export function useStandingOfferCancel(standingOfferId: string) {
  const { activeOrganization } = useUserActiveOrganization();

  return useMutation(STANDING_OFFER_CANCEL, {
    variables: {
      standingOfferId,
      organizationId: activeOrganization?.id || ""
    }
  });
}
